import { render, staticRenderFns } from "./createPassword.vue?vue&type=template&id=30f7a258&scoped=true"
import script from "./createPassword.vue?vue&type=script&lang=js"
export * from "./createPassword.vue?vue&type=script&lang=js"
import style0 from "./createPassword.vue?vue&type=style&index=0&id=30f7a258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f7a258",
  null
  
)

export default component.exports